import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useThemeContext } from '../global/ThemeContext';
import useTranslations from '../global/translation/hooks/translation'; // Import useTranslations

const Footer: FC = () => {
  const { darkMode } = useThemeContext();
  const { currentLanguage, translations } = useTranslations(); // Use the hook

  // Construct the translated string
  const designedByText = translations.other?.designedBy?.[currentLanguage] || 'Designed by'; // Add fallback

  return (
    <footer style={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          backgroundColor: darkMode ? '#232323' : '#F5F5F5',
          color: darkMode ? '#FFFFFF' : '#000000',
          boxShadow: darkMode ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          p: 1,
        }}
      >
        <Box sx={{ flexGrow: 0.5 }} />
        <Box>
          <Typography variant="body2" component="span" sx={{ color: darkMode ? '#FFFFFF' : '#000000' }} fontWeight={300}>
            {/* Use translated text */}© Urban Equestrian {new Date().getFullYear()} - {designedByText}&nbsp;
          </Typography>
          <Typography
            component="a"
            href="https://3dpros.pl/"
            sx={{
              textDecoration: 'none',
              color: darkMode ? '#FFFFFF' : '#000000',
              fontWeight: 'bold',
            }}
            fontWeight={300}
            color="inherit"
          >
            &nbsp;3DPros
          </Typography>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
